import { Box, Paper, Tooltip, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchWithToken } from "../../authentication/AuthProvider";
import AddButton from "../../components/button/AddButton";
import RefreshButton from "../../components/button/RefreshButton";
import { MainContainer } from "../../components/container/MainContainer";
import { PageTitleContainer } from "../../components/container/PageTitleContainer";
import { TableHeaderContainer } from "../../components/container/TableHeaderContainer";
import { TableHeaderToolsContainer } from "../../components/container/TableHeaderToolsContainer";
import { TableTitleContainer } from "../../components/container/TableTitleContainer";
import ContextMenu from "../../components/context-menu/ContextMenu";
import ExportAsXLSXButton from "../../components/export/ExportAsXLSXButton";
import SearchBox from "../../components/input/SearchBox";
import config from "../../config";
import { User } from "../../db_access/user";
import InvitationPartnership from "../Notification/InvitationPartnership";
import ButtonGenerateKey from "./Partnership/ButtonGenerateKey";
import DialogAddPartner from "./Partnership/DialogAddPartner";
import SnackbarCopiedToClipboard from "./Partnership/SnackbarCopiedToClipboard";

const CollaboratePartnership = () => {
  const { t } = useTranslation();
  const gridRef = useRef(null);
  const dialogRef = useRef();
  const [partners, setPartners] = useState([]);
  const [selectedPartners, setSelectedPartners] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const [searchText, setSearchText] = useState("");
  const [myInvitationKey, setMyInvitationKey] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [invitations, setInvitations] = useState([]);
  const getInvitations = () => {
    const url = config.partnership.get_my_pending_invitations_received;
    fetchWithToken(url, { ...config.method.POST })
      .then((res) => res.json())
      .then((data) => setInvitations(data));
  };
  const deletePartnership = () => {
    const url = config.partnership.delete;
    const body = {
      partner_company_ids: selectedPartners.map((s) => s.id),
    };
    fetchWithToken(url, {
      ...config.method.POST,
      headers: config.header.json,
      body: JSON.stringify(body),
    }).finally(() => {
      setSelectedPartners([]);
      setRefresh((r) => !r);
    });
  };
  const onSelectionChanged = (event) => {
    const selected = event.api.getSelectedRows();
    setSelectedPartners(selected);
  };
  const onCellValueChanged = (params) => {
    const { data } = params;
    const url = config.partnership.update_role;
    const body = {
      role: data.role,
      partner_company_id: data.id,
    };
    fetchWithToken(url, {
      ...config.method.POST,
      body: JSON.stringify(body),
      headers: config.header.json,
    });
  };
  const handleContextMenu = (e) => {
    e.preventDefault();
    setMenuPosition({ x: e.pageX, y: e.pageY });
    setMenuVisible(true);
  };
  const handleCloseMenu = () => {
    setMenuVisible(false);
  };
  const onGridReady = (_) => {
    const newDefs = columnDefs.map((col) => ({
      ...col,
      flex: undefined,
    }));
    setColumnDefs(newDefs);
  };
  const handleOpenDialog = () => {
    dialogRef.current?.open();
  };
  const defaultColDef = {
    filter: false,
    flex: 1,
    headerClass: "ag-center-aligned-header",
    wrapText: true,
    autoHeight: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
  };
  const centerAlignColDef = {
    cellStyle: {
      // fontFamily: "Poppins",
      textAlign: "center",
      lineHeight: "1.5",
      justifyContent: "center",
    },
  };
  const colDefs = [
    { field: "id", hide: true },
    {
      headerName: t("Name"),
      field: "name",
      editable: false,
      ...defaultColDef,
      ...centerAlignColDef,
    },
    {
      headerName: t("Role"),
      field: "role",
      editable: true,
      ...defaultColDef,
      ...centerAlignColDef,
      cellEditor: "agSelectCellEditor",
      cellEditorParams: {
        values: ["Supplier", "Client"],
      },
      onCellValueChanged: (params) => onCellValueChanged(params),
    },
  ];
  const [columnDefs, setColumnDefs] = useState(colDefs);
  const gridProps = {
    columnDefs: columnDefs,
    rowData: partners,
    rowSelection: "multiple",
    // domLayout: "autoHeight",
    onSelectionChanged: onSelectionChanged,
    getRowId: (params) => String(params.data.id),
  };
  const contextMenuOptions = [{ label: "Delete", action: deletePartnership, needSelectedItems: true }];
  useEffect(() => {
    const url = config.partnership.get_my_partners;
    fetchWithToken(url, {
      ...config.method.POST,
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          return null;
        }
      })
      .then((data) => {
        if (data) {
          setPartners(data);
        }
      });
  }, [refresh]);
  useEffect(() => {
    User.get_my_invitation_key()
      .then((res) => res.json())
      .then((data) => setMyInvitationKey(data[0]["invitation_key"]));
  }, [refresh]);
  useEffect(() => {
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.setGridOption("quickFilterText", searchText);
    }
  }, [searchText]);
  useEffect(() => console.log(selectedPartners), [selectedPartners]);
  useEffect(() => console.log(partners), [partners]);
  useEffect(() => getInvitations(), [refresh]);
  return (
    <MainContainer>
      <PageTitleContainer>
        <Box>
          <Typography variant="Page Title">Partnership</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            sx={{
              fontFamily: "Poppins",
              display: myInvitationKey === null ? "none" : "block",
            }}>
            My invitaion key:{" "}
            <Tooltip title={"Copy"} followCursor>
              <Box
                component="span"
                sx={{ fontWeight: 600 }}
                onClick={async () => {
                  try {
                    await navigator.clipboard.writeText(myInvitationKey);
                    setSnackbarOpen(true);
                  } catch (err) {
                    console.error("Copy to clipboard failed: ", err);
                  }
                }}>
                {myInvitationKey}
              </Box>
            </Tooltip>
          </Typography>
          <Typography
            sx={{
              fontFamily: "Poppins",
              display: myInvitationKey === null ? "block" : "none",
            }}>
            You don't have invitaion key
          </Typography>
          <ButtonGenerateKey setMyInvitationKey={setMyInvitationKey} />
        </Box>
      </PageTitleContainer>
      <Box>
        {invitations.map((inv, i) => (
          <Box key={i} sx={{ paddingY: 1 }}>
            <InvitationPartnership invitation={inv} setRefresh={setRefresh} />
          </Box>
        ))}
      </Box>
      <Paper variant="Table Container">
        <TableHeaderContainer>
          <TableTitleContainer>
            <Typography variant="Table Title">My Partners</Typography>
          </TableTitleContainer>
          <TableHeaderToolsContainer>
            <SearchBox text={searchText} setText={setSearchText} />
            <AddButton onClick={handleOpenDialog} labe={"Add Partner"} />
            <ExportAsXLSXButton data={partners} label="Download Partners" filename="partners.xlsx" />
            <RefreshButton />
          </TableHeaderToolsContainer>
        </TableHeaderContainer>
        <Box className="ag-theme-alpine grid-container" onContextMenu={handleContextMenu} sx={{ height: "500px" }}>
          <AgGridReact {...gridProps} ref={gridRef} domLayout="normal" onGridReady={onGridReady} />
        </Box>
      </Paper>
      <DialogAddPartner ref={dialogRef} onSuccess={() => setRefresh((r) => !r)} />
      <SnackbarCopiedToClipboard open={snackbarOpen} setOpen={setSnackbarOpen} />
      <ContextMenu x={menuPosition.x} y={menuPosition.y} visible={menuVisible} onClose={handleCloseMenu} selectedItems={selectedPartners} options={contextMenuOptions} />
    </MainContainer>
  );
};
export default CollaboratePartnership;
